export default __webpack_public_path__ + "d5f18881f7f833dfb0bd1a71f2d0f367.png";